import React, {useCallback} from 'react';
import AIMessageGenerator from '../aiMessageGenerator/AIMessageGenerator';
import type {
    AIMessageGeneratorEmptyStateProps,
    AIMessageGeneratorPromptAreaProps,
    AIMessageGeneratorUserMessageProps,
} from '../aiMessageGenerator/utils/types';
import AiAgentFab from './components/aiAgentFab/AiAgentFab';
import AiAgentEmptyState from './components/aiAgentEmptyState/AiAgentEmptyState';
import AiAgentSuggestions from './components/aiAgentSuggestions/AiAgentSuggestions';
import AiAgentUserMessage from './components/aiAgentUserMessage/AiAgentUserMessage';
import AiAgentPromptArea from './components/aiAgentPromptArea/AiAgentPromptArea';
import {useAiAgentPanel} from './hooks/useAiAgentPanel';

function AiAgent() {
    const {
        t,
        agentShow,
        openAgent,
        handleReset,
        handleSubmit,
        pendingAsk,
        clearAsk,
        sendMessageXHR,
        clearingFeePop,
    } = useAiAgentPanel();

    const renderEmptyState = useCallback(({onSuggestionClick}: AIMessageGeneratorEmptyStateProps) => (
        <AiAgentEmptyState>
            <AiAgentSuggestions onSuggestionClick={onSuggestionClick} />
        </AiAgentEmptyState>
    ), []);

    const renderPromptArea = useCallback((props: AIMessageGeneratorPromptAreaProps) => (
        <AiAgentPromptArea {...props} pendingAsk={pendingAsk} onClearAsk={clearAsk} />
    ), [pendingAsk, clearAsk]);

    const renderUserMessage = useCallback(({message, index, onEditMessage, draftLoading}: AIMessageGeneratorUserMessageProps) => (
        <AiAgentUserMessage
            message={message}
            index={index}
            onEditMessage={onEditMessage}
            draftLoading={draftLoading}
        />
    ), []);

    return (
        <>
            <AiAgentFab onClick={openAgent} />
            <AIMessageGenerator
                show={agentShow}
                title={t('title')}
                placeholder={t('inputPlaceholder')}
                newChatLabel={t('newChat')}
                errorMessage={t('errorMessage')}
                suggestions={[]}
                submit={{label: t('send'), onClick: handleSubmit, xhrState: sendMessageXHR}}
                renderEmptyState={renderEmptyState}
                renderPromptArea={renderPromptArea}
                renderUserMessage={renderUserMessage}
                onReset={handleReset}
                closeOnOutsideClick={false}
                hideBackdrop
                resetOnClose={false}
                dataCy="ai-agent"
            />
            {clearingFeePop}
        </>
    );
}

export default AiAgent;
